var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    { class: "c-list-item " + _vm.cssClasses },
    [
      _vm.variant === "custom"
        ? [_c("div", { domProps: { innerHTML: _vm._s(_vm.value) } })]
        : _vm.variant === "checkbox"
        ? [
            _c("vue-input", {
              ref: "listItemCheckbox",
              attrs: {
                label: _vm.label,
                "input-id": _vm.value,
                name: _vm.name,
                type: "checkbox"
              }
            })
          ]
        : _vm.variant === "router-link"
        ? [
            _c("router-link", { attrs: { to: _vm.value } }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]
        : [
            _c("span", { staticClass: "c-list-item__label" }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "t-text-style-epsilon",
              domProps: { innerHTML: _vm._s(_vm.value) }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }